var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0625 4.875H6.125V0.9375C6.125 0.71875 5.90625 0.5 5.6875 0.5H4.8125C4.56641 0.5 4.375 0.71875 4.375 0.9375V4.875H0.4375C0.191406 4.875 0 5.09375 0 5.3125V6.1875C0 6.43359 0.191406 6.625 0.4375 6.625H4.375V10.5625C4.375 10.8086 4.56641 11 4.8125 11H5.6875C5.90625 11 6.125 10.8086 6.125 10.5625V6.625H10.0625C10.2812 6.625 10.5 6.43359 10.5 6.1875V5.3125C10.5 5.09375 10.2812 4.875 10.0625 4.875Z",
    fill: "#276EF1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.746e93c38f6cef4b78a134e3c492c139.svg";
export { ForwardRef as ReactComponent };